import { render, staticRenderFns } from "./customer-inquiry.component.vue?vue&type=template&id=20852746&"
import script from "./customer-inquiry.component.ts?vue&type=script&lang=ts&"
export * from "./customer-inquiry.component.ts?vue&type=script&lang=ts&"
import style0 from "./customer-inquiry.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VTextarea})
